import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { InvitationColorMatrix, TemplateColorObject } from "../../InvitationColorMatrix";
import { InvitationColorPickerContainer } from "./styles";
const InvitationColorPicker = ({
	templateId,
	template_color,
	onColorPick
}: {
	templateId: number;
	template_color: number;
	onColorPick: (color: TemplateColorObject) => void;
}) => {
	const [colorObject, setColorObject] = useState<Record<number, TemplateColorObject>>(
		InvitationColorMatrix[templateId]
	);
	const [selectedColor, setSelectedColor] = useState<TemplateColorObject>(
		InvitationColorMatrix[templateId][template_color]
	);

	useEffect(() => {
		setColorObject(InvitationColorMatrix[templateId]);
	}, [templateId]);

	useEffect(() => {
		setSelectedColor(InvitationColorMatrix[templateId][template_color]);
	}, [templateId, template_color]);

	const templateColorList = useMemo(() => {
		const list = Object.entries(colorObject);
		return list.map(([, item]) => item) as TemplateColorObject[];
	}, [colorObject]);

	return (
		<InvitationColorPickerContainer gap={2} p={1}>
			{templateColorList.map(templateColor => (
				<Box key={templateColor.id} className={selectedColor?.id === templateColor.id ? "outlined" : ""}>
					<Box
						className={"color-box"}
						style={{
							backgroundColor: templateColor.main
						}}
						onClick={() => {
							setSelectedColor(templateColor);
							onColorPick(templateColor);
						}}
					/>
				</Box>
			))}
		</InvitationColorPickerContainer>
	);
};

export default InvitationColorPicker;
